export const delay = async (ms: number) => {
  return new Promise(resolve => setTimeout(() => resolve(true), ms));
}
